{
	"error": {
		"message": "Une erreur s'est produite lors du traitement de votre demande. Veuillez réessayer."
	},
	"placeholder": "Tapez votre message...",
	"initialMessage": "Bonjour, comment puis-je vous aider?"
}
